import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { SERVER_URL } from '../constants/server-type';

export default function EmailVerificationPage() {
    const { token } = useParams();
    const navigate = useNavigate();
    const [message, setMessage] = useState('Verifying email...');
    const [error, setError] = useState(false);

    useEffect(() => {
        fetch(`${SERVER_URL}/auth/verify-email/${token}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Verification failed.');
                }
                return response.json();
            })
            .then(data => {
                // ✅ Navigate to success page
                navigate('/verification-success', { replace: true });
            })
            .catch(() => {
                setError(true);
                setMessage('Verification failed or token already used.');
                // ✅ Optional: Redirect after delay
                setTimeout(() => navigate('/login', { replace: true }), 3000);
            });
    }, [token, navigate]);

    return (
        <div className="form-container">
            <h2>Email Verification</h2>
            <p>{message}</p>
            {error && <p>Redirecting to login...</p>}
        </div>
    );
}
